<template>
  <div>
    <div style="padding: 14px;">
      <div class="ellipsis">
        设备名称:
        <span :title="item.name">{{item.name}}</span>
      </div>
      <div class="ellipsis">
        设备地址:
        <span :title="item.name">{{item.area}}</span>
      </div>
      <div class="ellipsis">
        设备机房:
        <span :title="item.name">{{item.room}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'Device',
    props: {
        item: {
            type: Object,
            required: true,
            default: {}
        }
    }
}
</script>
<style scoped>
.ellipsis{
    /* display: inline; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>